import React, { useState } from 'react';
import Button from '../Button';
import InputFieldsComponent from '../InputFieldsSmall';
import './OTPVerification.css';
import Spinner from '../Spinner';

interface Props {
    labelNameForTextField?: string;
    lengthOfTextField?: number;
    handleInputFieldSubmit: (value: string) => void;
    errorMessage: string;
    isError: boolean;
    setIsError: any;
    inputFieldSpinner?: boolean;
    defaultInputValue?: string;
}
const TextFieldComponent: React.FC<Props> = ({
    labelNameForTextField = 'Enter Mobile Number',
    lengthOfTextField = 10,
    handleInputFieldSubmit,
    errorMessage,
    isError,
    setIsError,
    inputFieldSpinner = false,
    defaultInputValue = ''
}) => {
    const [inputNumber, setInputNumber] = useState<string>(defaultInputValue);
    const handleChange = (value: string) => {
        value = value.replace(/\D/g, '').slice(0, lengthOfTextField); // Remove non-numeric characters and limit length
        setInputNumber(value);
        setIsError(false);
    }
    const handleSubmit = () => {
        if (inputNumber.length < lengthOfTextField!) {
            return;
        }
        handleInputFieldSubmit(inputNumber);
    }
    return (
        <>

            <div className='otp_verification_textfield_component'>
                <div className='otp_verification_input_fields'>
                    <InputFieldsComponent
                        labelName={labelNameForTextField}
                        placeholder={"Type Here"}
                        type={'text'}
                        isDisabled={false}
                        onChange={handleChange}
                        value={inputNumber}
                        maximumLength={lengthOfTextField}
                        inputType={isError ? 'error' : 'general'}
                        required={true}
                        errorMessage={errorMessage}                      
                    />
                </div>
                  <span>{inputFieldSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                <div className='text_field_button_submit'>
                    <Button
                        onClick={handleSubmit}
                        disabled={inputNumber?.length === lengthOfTextField ? false : true}
                        id="otp_verification_button_submit"
                        buttonName={'Submit'}
                        colorType={'primary'}
                    />
                </div>
            </div>
        </>
    );
};

export default TextFieldComponent;
